<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>保险管理系统</el-breadcrumb-item>
        <el-breadcrumb-item>保险申请</el-breadcrumb-item>
        <el-breadcrumb-item>查看详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="my-container box-shadow">
      <div style="padding: 20px;border-bottom: 1px solid #DBDBDB;">
        <div style="font-size: 22px;">投保反馈</div>
      </div>

      <div class="main-info">
        <el-form
          id="myForm"
          :label-position="labelPosition"
          style="width:400px;margin-left: 175px;margin-top: 30px;"
          :model="form"
          :rules="rules"
          ref="form"
        >
          <el-form-item label="保险金额：" prop="price">
            <el-input v-model.number="form.price" size="small" placeholder="请输入保险金额" style="float:left;width:250px;" clearable>
            </el-input>
          </el-form-item>

          <el-form-item label="投保年限：" prop="yearNo">
            <el-input v-model="form.yearNo" size="small" placeholder="请输入投保年限" style="float:left;width:250px;" clearable> </el-input>
          </el-form-item>

          <el-form-item label="保单号：" prop="cno">
            <el-input v-model="form.cno" size="small" placeholder="请输入保单号" style="float:left;width:250px;" clearable> </el-input>
          </el-form-item>
        </el-form>

        <div class="gap">
          <div>电子保单</div>
          <hr />
        </div>

        <!--电子保单-->
        <div class="info-item">
          <div style="margin-top: 30px;margin-left: 175px;width: 370px;" v-loading="uploading">
            <div class="el-upload el-upload--text" style="position: relative;">
              <button type="button" class="el-button el-button--primary el-button--small">
                <span>点击上传</span>
              </button>
              <input id="uploadDom" @change="doUpload" accept=".pdf" type="file" name="file" class="hidden-upload" />
            </div>
            <div class="el-upload__tip">只能上传pdf文件</div>
            <ul class="el-upload-list el-upload-list--text" v-if="fileList.length > 0">
              <li class="el-upload-list__item is-success" v-for="(item, index) in fileList" :key="index">
                <a class="el-upload-list__item-name"> <i class="el-icon-document"></i>{{ item.name }} </a>
                <label class="el-upload-list__item-status-label">
                  <i class="el-icon-upload-success el-icon-circle-check"></i>
                </label>
                <i class="el-icon-close" @click="deletePdf(index)"></i>
              </li>
            </ul>
          </div>
        </div>

        <div style="text-align: center;margin-top: 70px;">
          <el-button @click="link2Detail" style="width: 200px;">取 消</el-button>
          <el-button type="primary" @click="feedback" style="width: 200px;">确 定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    var yearValid = (rule, value, callback) => {
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error("请输入正整数"));
      } else {
        if (value < 0 || value >= 50) {
          callback(new Error("投保年限不能大于50年"));
        } else {
          callback();
        }
      }
    };

    var moneyValid = (rule, value, callback) => {
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error("请输入正整数"));
      } else {
        if (value > 100000000) {
          callback(new Error("投保金额不能大于1亿"));
        } else {
          callback();
        }
      }
    };

    return {
      labelPosition: "right",
      form: {
        price: "",
        yearNo: "",
        cno: ""
      },
      fileList: [],
      uploading: false,
      rules: {
        price: [
          { required: true, message: "请输入保险金额", trigger: "blur" },
          { validator: moneyValid, trigger: "blur" }
        ],
        yearNo: [
          { required: true, message: "请输入投保年限", trigger: "blur" },
          { validator: yearValid, trigger: "blur" }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    feedback() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.fileList.length === 0) {
            this.$message({
              message: "请上传电子保单！",
              type: "warning"
            });
            return;
          }
          this.postData();
        } else {
          this.$message({
            message: "请确认信息填写无误再提交！",
            type: "warning"
          });
          return false;
        }
      });
    },
    postData() {
      const bodyParams = Object.assign(
        {},
        {
          id: this.$route.query.id,
          price: this.form.price,
          cno: this.form.cno,
          yearNo: this.form.yearNo,
          pdfUrl: this.fileList[0].url
        }
      );

      const self = this;
      this.$http({
        url: global.apiUrl + "/carInsurance/return",
        method: "POST",
        body: bodyParams
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            self.$router.push({
              name: "carInsuranceDetail",
              query: {
                id: self.$route.query.id
              }
            });
          } else {

          }
        })
        .catch((err) => {

          console.error(err);
        });
    },
    /**
     * 上传文件
     */
    doUpload() {
      if (this.fileList.length >= 1) {
        this.$message.error("只能上传一个pdf文件");
        return;
      }
      this.uploading = true;
      const files = document.getElementById("uploadDom").files;
      const file = files[0];

      const params = new FormData();
      params.append("file", file);
      params.append("path", "upload/carInstance-pdf");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then((res) => {
          this.uploading = false;
          this.fileList.push(res.data);
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * 删除文件
     * @param index
     */
    deletePdf(index) {
      this.fileList.splice(index, 1);
    },
    link2Detail() {
      const id = this.$route.query.id;
      this.$router.push({
        name: "carInsuranceDetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style>
.hidden-upload {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: 2;
  cursor: pointer;
}

.my-container {
  min-height: 500px;
  margin-top: 30px;
}

.my-title {
  float: none;
  height: 32px;
  line-height: 32px;
  font-size: 22px;
}

.main-info {
  padding: 0 0 30px 30px;
}

.my-row {
  margin-left: 160px;
  padding: 30px 0;
}

.my-row .text {
  float: left;
}

.my-row .text:first-child {
  width: 100px;
  text-align: right;
}

.my-row .text:last-child {
  margin-left: 40px;
}

.gap {
  position: relative;
  margin-top: 30px;
  margin-left: 40px;
}

.gap hr {
  height: 2px;
  border: none;
  border-top: 2px solid #dbdbdb;
}

.gap div {
  position: absolute;
  width: 90px;
  text-align: right;
  top: -11px;
  background: #fff;
  padding-right: 20px;
  font-size: 17px;
  font-weight: bold;
  color: #54b153;
}

.my-img {
  width: 300px;
  margin: 20px 0 0 153px;
  border: 1px solid #dbdbdb;
}

#myForm .el-form-item__label {
  width: 95px;
}

#myForm .el-form-item__error {
  left: 100px;
}
</style>
